export default __webpack_public_path__ + "static/media/_england.73d9b29c.ico";